<template>
    <div>
        <div v-show="options_loaded && passed_filter && panel_required">
            <div class="designeroption" :data-designer-component-id="component_id">
                <h3 v-if="title">
                    {{ title }}
                    <component-filter-box v-if="componentFilterBox" v-model:search-filter="filterSearch"></component-filter-box>
                    <designer-question-popup-info
                        v-if="has_popup_info"
                        :popup_info_title_html="popup_info_title_html"
                        :popup_info_inner_html="popup_info_inner_html"
                    ></designer-question-popup-info>
                </h3>
                <div class="designer-floating-sidebar-message" v-if="floating_sidebar_message">
                    <i class="fa fa-circle-question"></i>
                    <span v-html="floating_sidebar_message"></span>
                </div>
                <div class="stylesoption designer-question-tiled-layout" :class="modifier_class" v-if="!loading">
                    <div class="tile"
                         @click.prevent="localTarget = option.value"
                         :class="[localTarget == option.value ? 'active showtitle' : '']"
                         v-for="option in filtered_option_list"
                         :key="option.value">
                        <a href="#">
                            <designer-thumbnail :label="option.label" :thumb_path="getThumbUrlFor(option.value)" :fabricator="fabricator"></designer-thumbnail>
                            <label>{{ option.label }}</label>
                            <i class="fa fa-check" aria-hidden="true"></i>
                            <div class="thumbnail-helper-hover" v-html="thumbnailHelperHover(option)" @click.prevent="copyThumbUrlToClipboard(option)"></div>
                        </a>
                    </div>
                    <!--flexbox hack-->
                    <div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div><div class="tile-empty"></div>
                </div>
                <div v-if="loading">
                    <p>Loading Options</p>
                </div>
                <div class="stylesoption" v-if="helper_text" v-html="helper_text"></div>
                <div class="stylesoption" v-if="extra_text" v-html="extra_text"></div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import ComponentFilterBox from "../ComponentFilterBox.vue";
    import DesignerQuestionPopupInfo from "../DesignerQuestionPopupInfo.vue";

    export default {
        components: {
            ComponentFilterBox,
            DesignerQuestionPopupInfo,
        },
        emits: ['update:target'],
        props: {
            options_loaded: {
                required: true
            },
            passed_filter: {
                required: true
            },
            title: {
                required: true
            },
            component_id: {
                required: false
            },
            loading: {
                required: true
            },
            target: {
                required: true
            },
            modifier_class: {
                required: false,
            },
            filtered_option_list: {
                required: true
            },
            thumb_url: {
                required: true
            },
            panel_required: {
                required: false,
                default(){
                    return true;
                }
            },
            helper_text: {
                required: false,
            },
            fabricator: {
                required: true,
            },
            has_popup_info: {
              default(){
                return false;
              }
            },
            popup_info_title_html: {
              default(){
                return '';
              }
            },
            popup_info_inner_html: {
              default(){
                return '';
              }
            },
            extra_text: {
              default(){
                return '';
              }
            },
            floating_sidebar_message: {
                default(){
                    return '';
                }
            },
            show_empty_tiles: {
              default(){
                return true;
              }
            },
            componentFilterBox: {
                required: false,
                default(){
                    return false;
                }
            },
        },
        computed: {
            localTarget: {
                get() {
                    return this.target
                },
                set(val) {
                    this.$emit('update:target', val)
                }
            },
        },
        methods: {
            getThumbUrlFor(value){
                return this.thumb_url + value;
            },
            thumbnailHelperHover(option){
                if(window.isBing && option.thumb_path){
                    return option.value + ' - ' + option.thumb_path;
                }
                return '';
            },
            copyThumbUrlToClipboard(option){
                navigator.clipboard.writeText(option.thumb_path)
            },
        },
    }
</script>
